import { render, staticRenderFns } from "./BuddhaDetail.vue?vue&type=template&id=6b1aa912&scoped=true"
import script from "./BuddhaDetail.vue?vue&type=script&lang=js"
export * from "./BuddhaDetail.vue?vue&type=script&lang=js"
import style0 from "./BuddhaDetail.vue?vue&type=style&index=0&id=6b1aa912&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1aa912",
  null
  
)

export default component.exports